<div id="comment" class="comment">
  <div id="comment-heading" class="comment-heading">
    <div id="comment-user-name-dept" class="comment-user-name-dept">
      <app-text
        id="commnt-user-name"
        [textStyleType]="'body1'"
        class="comment-user-name"
        >{{ commentData.userName }}</app-text
      >
      <app-text
        id="comment-user-department"
        [textStyleType]="'caption'"
        class="comment-user-department"
        >{{ commentData.department }}</app-text
      >
    </div>
    <div id="comment-time" class="comment-time">
      <app-text
        id="comment-heading-datetime"
        class="comment-heading-datetime"
        [textStyleType]="'caption'"
        >{{
          commentData.createdTime | date : "dd/MM/yyyy '\at'\ HH:mm"
        }}</app-text
      >
      <app-text
        id="comment-time-edited"
        *ngIf="commentData.createdTime !== commentData.modifiedTime"
        class="comment-time-edited"
        [textStyleType]="'caption'"
        >{{ "comment.commentTime.commenTimeEdited.text" | translate }}</app-text
      >
    </div>
  </div>
  <div
    *ngIf="commentData.systemCode"
    id="comment-system-tag"
    class="comment-system-tag"
  >
    <app-chip
      id="comment-chip-po-id"
      *ngIf="commentData.purchaseOrderId"
      class="comment-chip comment-chip-po"
      [predefinedChipStylingClassName]="'chip-grey'"
    >
      {{ getPOtagText() }}
    </app-chip>
    <app-chip
      *ngIf="commentData.systemCode.description"
      id="comment-chip-id"
      class="comment-chip"
      [predefinedChipStylingClassName]="'chip-yellow'"
      [iconName]="'sticky_note_2'"
      [showIcon]="true"
      [iconSize]="'1em'"
    >
      {{ commentData.systemCode.description }}</app-chip
    >
  </div>
  <div
    *ngIf="commentData.stockAdjustmentCode"
    id="comment-stockadjustment-code"
    class="comment-system-tag"
  >
    <app-chip
      id="comment-stockadjustment-code"
      class="comment-chip comment-chip-po"
      [predefinedChipStylingClassName]="'chip-yellow'"
    >
      {{ commentData.stockAdjustmentCode }}
    </app-chip>
  </div>
  <div
    *ngIf="checkIsEditMode(); else commentReadMode"
    id="update-comment"
    class="update-comment"
  >
    <app-textarea
      #editCommentTextArea
      (click)="checkIsOnClick()"
      (keyup)="getUpdatedComment($event)"
      (enterPress)="getUpdatedComment($event)"
      [placeholderText]="'guardhouse.comments.textArea.placeholder' | translate"
      [textareaWidth]="'getTextAreaStyle()'"
      [textareaHeight]="'5em'"
      [characterLimit]="150"
    ></app-textarea>

    <div id="update-comment-detail" class="update-comment-detail">
      <div
        *ngIf="isOnClick || updatedComment"
        id="update-comment-detail-btns"
        class="update-comment-detail-btns"
      >
        <div id="update-comment-cancel-btn" class="update-comment-cancel-btn">
          <app-button
            id="update-comment-cancel-button"
            [text]="'comment.updateCommentDetail.cancelBtn.text' | translate"
            [buttonType]="'secondary'"
            (buttonClick)="onCancel()"
          >
          </app-button>
        </div>
        <div id="update-comment-update-btn" class="update-comment-update-btn">
          <app-button
            id="update-comment-update-button"
            [text]="
              'comment.updateCommentDetail.saveChangesBtn.text' | translate
            "
            [buttonType]="getButtonType()"
            (buttonClick)="onSaveChanges(commentData)"
          >
          </app-button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #commentReadMode id="comment-read-mode">
    <div id="comment-msg-and-btns">
      <div id="comment-msg" [class]="commentMessageClass">
        <app-text
          id="comment-msg-text"
          [textStyleType]="commentMessageTextStyle"
          >{{ commentData.description }}</app-text
        >
      </div>
      <div
        *ngIf="isCommentsEditable(commentData)"
        id="comment-msg-btns"
        class="comment-msg-btns"
      >
        <app-button
          *ngIf="showEditBtn"
          id="comment-msg-edit-btn"
          class="comment-msg-edit-btn"
          [text]="'comment.commentMsgBtns.editBtn.text' | translate"
          [isTextLinkBtn]="'true'"
          [buttonType]="'textLink'"
          (buttonClick)="onEditClick(commentData)"
        >
        </app-button>
        <app-button
          *ngIf="showDeleteBtn"
          id="comment-msg-delete-btn"
          class="comment-msg-delete-btn"
          [text]="'comment.commentMsgBtns.deleteBtn.text' | translate"
          [isTextLinkBtn]="'true'"
          [buttonType]="'textLink'"
          (buttonClick)="onDeleteClick(commentData)"
        >
        </app-button>
      </div>
    </div>
  </ng-template>
</div>

<div>
  <ng-template #deleteCommentDialogRef id="delete-comment-popup-modal">
    <app-text
      id="delete-comment-popup-modal-text"
      [textStyleType]="'headline5'"
      >{{ "comment.deleteCommentPopupModal.subHeading" | translate }}</app-text
    >
    <div
      id="delete-comment-popup-modal-btns"
      class="delete-comment-popup-modal-btns"
    >
      <div
        id="delete-comment-cancel-btn-modal"
        class="update-comment-cancel-btn"
      >
        <app-button
          id="delete-comment-popup-modal-button"
          [text]="'comment.deleteCommentPopupModal.cancelBtn.text' | translate"
          [buttonType]="'secondary'"
          (buttonClick)="onCancelCommentDelete()"
        >
        </app-button>
      </div>
      <div id="update-comment-update-btn" class="update-comment-update-btn">
        <app-button
          id="update-comment-popup-modal-button"
          [text]="'comment.deleteCommentPopupModal.deleteBtn.text' | translate"
          [buttonType]="'primary'"
          (buttonClick)="onConfirmCommentDelete()"
        >
        </app-button>
      </div>
    </div>
  </ng-template>
</div>
